import Tabs from 'Chakra/Tabs';
import { Box } from '@chakra-ui/react';
import { localizeAndFormat } from 'Shared/utils/numberFormat';

export function UserTabs({
   viewTabs,
   notifBadge,
   currentTab,
   setCurrentTab,
}: {
   viewTabs: any[];
   notifBadge: number;
   currentTab: string;
   setCurrentTab: (name: string) => void;
}) {
   const viewTabsWithHandlers = viewTabs.map((tabObject: any) => {
      const obj = {
         ...tabObject,
         handler: () => {
            setCurrentTab(tabObject.name);
            window.history.replaceState(null, '', tabObject.url + window.location.search);
         },
      };
      if (tabObject.name === 'Notifications' && notifBadge > 0) {
         obj.badge = localizeAndFormat(notifBadge, { notation: 'compact' });
      }
      return obj;
   });
   const activeIndex = viewTabs.findIndex((tab: any) => tab.name === currentTab);

   return (
      <Box m="8px 0 24px">
         <Tabs activeTab={activeIndex} tabsData={viewTabsWithHandlers} fitted={false} />
      </Box>
   );
}
